import React, { Component } from 'react';
import classes from './Modal.css';
import Box from '../../../hoc/Box/Box';
import Backdrop from '../Backdrop/Backdrop';

class Modal extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextProps.show !== this.props.show ||
      nextProps.children !== this.props.children
    );
  }

  getStyle = () => {
    let style = {
      transform: this.props.show ? 'translateY(0)' : 'translateY(-100vh)',
      opacity: this.props.show ? '1' : '0',
      zIndex:3000
    }
    if (this.props.customStyle) {
      style = {
        ...style,
        ...this.props.customStyle
      }
    }

    return style;
  }

  render() {
    return (
      <Box>
        <Backdrop
          noBackShadow={this.props.devDeets}
          show={this.props.show}
          clicked={this.props.modalClosed}
        />

        {/* <Backdrop show={this.props.show} clicked={this.props.modalClosed} /> */}
        <div
         id={this.props.id ? this.props.id : ''}
          className={
            this.props.ipResDev === 'true'
              ? classes.ipResModal
              : this.props.editDevName === 'true'
              ? classes.editModal
              : this.props.devDeets === 'true'
              ? classes.devDeetsModal
              : this.props.deviceGroupConfirmation === 'true'
              ? classes.deviceGroupConfirmationModal
              : this.props.ipResAddDev === 'true'
              ? classes.ipResAddModal
              : this.props.deviceNameConfirmationModal
              ? classes.deviceNameConfirmationModal
              :this.props.handleToggleUpnp
              ? classes.UpnpModal
              : this.props.fullWidth === 'true'
              ? classes.togglePodModal
              : classes.Modal
              
          }
          style={this.getStyle()}
        >
          {(this.props.deviceGroupConfirmation === 'true' ||
            this.props.showCloseIcon) && (
            <span
              id="modalX"
              className={classes.CloseIcon}
              onClick={this.props.modalClosed}
            >
              x
            </span>
          )}
          {this.props.children}
        </div>
      </Box>
    );
  }
}

export default Modal;
